import { combineReducers } from "redux";

import addressReducer from "./addressReducer";
import appReducer from "./appReducer";
import blockReducer from "./blockReducer";
import blocksReducer from "./blocksReducer";
import chainReducer from "./chainReducer";
import metaReducer from "./metaReducer";
import priceReducer from "./priceReducer";
import statusReducer from "./statusReducer";
import txReducer from "./txReducer";
import txsReducer from "./txsReducer";

// Combine all reducers
const rootReducer = combineReducers({
  address: addressReducer,
  app: appReducer,
  block: blockReducer,
  blocks: blocksReducer,
  chain: chainReducer,
  meta: metaReducer,
  price: priceReducer,
  status: statusReducer,
  tx: txReducer,
  txs: txsReducer,
});

// Infer the `RootState` and `AppDispatch` types from the rootReducer itself
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
